/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Product bundle block ("custom.bundle_products" metafield-driven add-ons).
 * Initializes every [data-bundle-widget] on the page (in practice, at most one
 * per product page, since the block is limited to one instance per section).
 */
(function () {
  function formatMoney(cents) {
    var format = window.theme && window.theme.currencyCodeEnabled
      ? window.theme.moneyWithCurrencyFormat
      : window.theme.moneyFormat;

    if (!format) {
      return '' + (cents / 100).toFixed(2);
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = typeof thousands === 'undefined' ? ',' : thousands;
      decimal = typeof decimal === 'undefined' ? '.' : decimal;

      if (isNaN(number) || number == null) {
        return '0';
      }

      number = (number / 100).toFixed(precision);

      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';

      return dollars + centsPart;
    }

    var match = format.match(placeholderRegex);
    var token = match ? match[1] : 'amount';
    var value;

    switch (token) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(cents, 0, ' ', ',');
        break;
      default:
        value = withDelimiters(cents, 2);
    }

    return format.replace(placeholderRegex, value);
  }

  function getMainFormState(formId) {
    var form = formId && document.getElementById(formId);

    if (!form) {
      return { variantId: null, quantity: 1, form: null };
    }

    var data = new FormData(form);
    var variantId = parseInt(data.get('id'), 10);
    var quantity = parseInt(data.get('quantity'), 10);

    return {
      form: form,
      variantId: isNaN(variantId) ? null : variantId,
      quantity: isNaN(quantity) || quantity < 1 ? 1 : quantity
    };
  }

  function initBundleWidget(widget) {
    var checkboxes = Array.prototype.slice.call(widget.querySelectorAll('[data-bundle-checkbox]'));
    var mainPriceElement = widget.querySelector('[data-bundle-main-price]');
    var totalElement = widget.querySelector('[data-bundle-total]');
    var savingsElement = widget.querySelector('[data-bundle-savings]');
    var savingsTextElement = widget.querySelector('[data-bundle-savings-text]') || savingsElement;
    var addButton = widget.querySelector('[data-bundle-add-button]');
    var feedbackElement = widget.querySelector('[data-bundle-feedback]');
    var formId = widget.getAttribute('data-bundle-product-form-id');
    var addUrl = widget.getAttribute('data-bundle-add-url');
    var mainProductId = widget.getAttribute('data-bundle-main-product-id');
    var errorMessage = widget.getAttribute('data-bundle-error-message');
    var savingsTemplate = widget.getAttribute('data-bundle-savings-template') || '';
    var mainPriceCents = parseInt(mainPriceElement && mainPriceElement.getAttribute('data-bundle-main-price-cents'), 10) || 0;

    function updateSummary() {
      var quantity = getMainFormState(formId).quantity;
      var addonsTotal = 0;
      var addonsSavings = 0;
      var hasChecked = false;

      checkboxes.forEach(function (checkbox) {
        if (checkbox.checked) {
          hasChecked = true;
          var price = parseInt(checkbox.getAttribute('data-bundle-price'), 10) || 0;
          var originalPrice = parseInt(checkbox.getAttribute('data-bundle-original-price'), 10) || price;
          addonsTotal += price;
          addonsSavings += originalPrice - price;
        }
      });

      var total = mainPriceCents * quantity + addonsTotal;

      if (totalElement) {
        totalElement.textContent = formatMoney(total);
      }

      if (savingsElement) {
        if (addonsSavings > 0) {
          savingsTextElement.textContent = savingsTemplate.replace('__AMOUNT__', formatMoney(addonsSavings));
          savingsElement.hidden = false;
        } else {
          savingsElement.hidden = true;
        }
      }

      if (addButton) {
        addButton.disabled = !hasChecked;
      }
    }

    checkboxes.forEach(function (checkbox) {
      checkbox.addEventListener('change', updateSummary);

      var item = checkbox.closest('[data-bundle-item]');

      if (item) {
        item.addEventListener('click', function (event) {
          if (checkbox.disabled || event.target.closest('a') || event.target === checkbox) {
            return;
          }

          checkbox.checked = !checkbox.checked;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    });

    var mainState = getMainFormState(formId);

    if (mainState.form) {
      mainState.form.addEventListener('input', function (event) {
        if (event.target && event.target.name === 'quantity') {
          updateSummary();
        }
      });

      mainState.form.addEventListener('change', function (event) {
        if (event.target && event.target.name === 'quantity') {
          updateSummary();
        }
      });
    }

    document.documentElement.addEventListener('variant:change', function (event) {
      var variant = event.detail && event.detail.variant;

      if (!variant) {
        return;
      }

      mainPriceCents = variant.price;

      if (mainPriceElement) {
        mainPriceElement.setAttribute('data-bundle-main-price-cents', variant.price);
        mainPriceElement.textContent = formatMoney(variant.price);
      }

      updateSummary();
    });

    if (addButton) {
      addButton.addEventListener('click', function () {
        var state = getMainFormState(formId);

        if (!state.variantId) {
          return;
        }

        var items = [{ id: state.variantId, quantity: state.quantity }];

        checkboxes.forEach(function (checkbox) {
          if (checkbox.checked) {
            items.push({
              id: parseInt(checkbox.getAttribute('data-bundle-variant-id'), 10),
              quantity: 1,
              properties: { _bundle: mainProductId }
            });
          }
        });

        addButton.setAttribute('disabled', 'disabled');
        checkboxes.forEach(function (checkbox) {
          checkbox.disabled = true;
        });

        if (feedbackElement) {
          feedbackElement.hidden = true;
        }

        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        fetch(addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: items })
        }).then(function (response) {
          checkboxes.forEach(function (checkbox) {
            checkbox.disabled = false;
          });

          if (response.ok) {
            var totalQuantity = items.reduce(function (sum, item) { return sum + item.quantity; }, 0);

            document.documentElement.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: null,
                quantity: totalQuantity,
                productAdded: true
              }
            }));

            checkboxes.forEach(function (checkbox) {
              checkbox.checked = false;
            });
            updateSummary();
          } else {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            addButton.removeAttribute('disabled');

            response.json().then(function (content) {
              if (feedbackElement) {
                feedbackElement.textContent = (content && (content.description || content.message)) || errorMessage;
                feedbackElement.hidden = false;
              }
            }).catch(function () {
              if (feedbackElement) {
                feedbackElement.textContent = errorMessage;
                feedbackElement.hidden = false;
              }
            });
          }
        }).catch(function () {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          checkboxes.forEach(function (checkbox) {
            checkbox.disabled = false;
          });
          addButton.removeAttribute('disabled');

          if (feedbackElement) {
            feedbackElement.textContent = errorMessage;
            feedbackElement.hidden = false;
          }
        });
      });
    }

    updateSummary();
  }

  var bundleWidgets = document.querySelectorAll('[data-bundle-widget]');

  for (var i = 0; i < bundleWidgets.length; i++) {
    initBundleWidget(bundleWidgets[i]);
  }
})();

